module.exports = __webpack_public_path__ + "static/media/ico-dropdown.c56fff30.svg";